import React, { useState } from 'react'
import style from './storagebox.module.css'
import { showStorageWrapperAtom, iframeAtom, chatLangAtom } from '../../../store'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import { BsDiscord } from "react-icons/bs"
import { RiBilibiliFill } from "react-icons/ri"
import { RxVideo } from "react-icons/rx"
import { AiFillYoutube, AiOutlineTwitter } from "react-icons/ai"
import { mockData, collectionData } from './mock/mock'
import storage_back from '../../../assets/storage_back.png'
import storageBox_icon from '../../../assets/storageBox_icon.png'

const StorageBox = React.forwardRef((props, ref) => {
  const chatLang = useRecoilValue(chatLangAtom);
  const [showStorageWrapper, setShowStorageWrapper] = useRecoilState(showStorageWrapperAtom)
  const setIframe = useSetRecoilState(iframeAtom)
  const [showCollection, setShowCollection] = useState(false)
  const [curTutorialCollectionIndex, setCurTutorialCollectionIndex] = useState(0)
  const [tutorialData,] = useState(chatLang === "Chinese" ? collectionData.chinese : collectionData.english)

  const handlerClickCollection = (index) => {
    setShowCollection(tutorialData[index].title)
    setCurTutorialCollectionIndex(index)
  }

  return <>
    <div className={style.storageBox} onClick={() => setShowStorageWrapper(true)}>
      <img src={storageBox_icon} alt="storageBox_icon" />
    </div>
    <div ref={ref} className={`${style.storageWrapper} ${showStorageWrapper ? style.show : ""}`}>
      <div
        className={style.storageContent}>
        <div className={`${style.storageMain}`}>

          <div className={`${style.collectionBack} ${showCollection ? style.showCollection : ""}`} onClick={() => setShowCollection(false)}>
            <img className={style.backArrow} src={storage_back} alt="storage_back" />
            <span>{showCollection}</span>
          </div>
          {!showCollection && tutorialData.map((item, index) => {
            return (
              <div
                className={style.videoItem}
                key={index}
                onClick={handlerClickCollection.bind(null, index)}>
                <div className={style.itemLeft}>
                  <img src={item.coverimg} alt={item.coverimg} />
                  <div className={style.bottomMask}>{item.arrData.length}个视频</div>
                  <RxVideo className={style.videoPlay} />
                </div>
                <div className={style.itemRight}>
                  <div className={style.itemTitle} title={item.title}>{item.title}</div>
                  <div className={style.itemMsg}> {item.update_time}</div>
                </div>
              </div>
            )
          })}
          {(showCollection ? tutorialData[curTutorialCollectionIndex].arrData : mockData).map((item, index) => {
            return <div
              className={style.videoItem}
              key={index}
              onClick={() => setIframe({ type: "Youtube", src: item.iframe })}>
              <div className={style.itemLeft}>
                <img src={item.src} alt={item.src} />
                <span>{item.duration}</span>
                <RxVideo className={style.videoPlay} />
              </div>
              <div className={style.itemRight}>
                <div className={style.itemTitle} title={item.title}>{item.title}</div>
                <div className={style.itemMsg}> {item.message}</div>
              </div>
            </div>
          })}

        </div>
      </div>
      <div className={style.storageFooter}>
        {[{
          svg: <BsDiscord fontSize={'22px'} />,
          href: 'https://discord.com/invite/AhYWCT8WNH'
        }, {
          svg: <RiBilibiliFill style={{
            // color: 'rgb(0,161,214)',
            fontSize: '22px'
          }} />,
          href: 'https://space.bilibili.com/1509136598'
        }, {
          svg: <AiFillYoutube style={{
            // color: "red",
            fontSize: '22px'
          }} />,
          href: 'https://www.youtube.com/@DeemosTech'
        }, {
          svg: <AiOutlineTwitter style={{
            // color: '#00acee',
            fontSize: '22px'
          }} />,
          href: 'https://twitter.com/DeemosTech'
        }].map((item) => {
          return <a key={item.href} href={item.href} target='_blank' rel="noreferrer"   > {item.svg}</a>
        })}
      </div>
    </div>

  </>
})


StorageBox.displayName = "StorageBox"
export { StorageBox }

